import { render, staticRenderFns } from "./IconBelt.vue?vue&type=template&id=6ec6b483"
import script from "./IconBelt.vue?vue&type=script&lang=js"
export * from "./IconBelt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports